import { render } from "./home-view-def.vue?vue&type=template&id=5cd99725"
import script from "./home-view-def.vue?vue&type=script&lang=js"
export * from "./home-view-def.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/home-view/home-view-def.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5cd99725"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5cd99725', __exports__)) {
    api.reload('5cd99725', __exports__)
  }
  
  module.hot.accept("./home-view-def.vue?vue&type=template&id=5cd99725", () => {
    api.rerender('5cd99725', render)
  })

}


export default __exports__